import { combineEpics } from 'redux-observable';
import clear from './clear/epic.tsx';
import reSort from './re-sort/epic.tsx';
import set from './set/epic.tsx';

export default combineEpics(clear, set, reSort);
